import { createVanIconComponent } from "./van"

const PhotoFail = createVanIconComponent("photo-fail")
export default PhotoFail
